import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface LabelValueProps {
    icon?: ReactNode;
    label?: string;
    value: string | number | React.ReactNode;
    variant?: 'caption' | 'body2';
    color?: string;
    gap?: number;
    alignItems?: 'center' | 'flex-start' | 'flex-end';
}

export const LabelValueRow = ({
    icon,
    label,
    value,
    variant = 'body2',
    color = 'textSecondary',
    gap = 1,
    alignItems = 'center',
}: LabelValueProps) => {
    return (
        <Stack
            direction={'row'}
            gap={gap}
            alignItems={alignItems}
            paddingTop={0.5}
        >
            {icon}
            {label && (
                <Typography color={color} variant="caption" flexShrink={0}>
                    {label} :
                </Typography>
            )}
            {typeof value === 'string' || typeof value === 'number' ? (
                <Typography variant={variant} flex={1}>
                    {value}
                </Typography>
            ) : (
                <Box
                    display="flex"
                    flexWrap="wrap"
                    columnGap={0.5}
                    rowGap={0}
                    flex={1}
                >
                    {value}
                </Box>
            )}
        </Stack>
    );
};
